import axios from 'axios';

// Public website banners (announcements). The backend returns only currently
// active banners already ordered for display.
export const bannersService = {
  async getActive() {
    const res = await axios.get('/banners');
    return res.data.data || [];
  },
};
